const LogoWhiteIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    aria-hidden='true'
    width='125'
    height='32'
    viewBox='0 0 125 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clipLogoWhiteIcon)'>
      <path
        d='M120.168 26.9594C121.78 26.9594 123.161 25.6611 123.161 23.9809C123.161 22.3007 121.78 21.0024 120.168 21.0024C118.48 21.0024 117.176 22.3007 117.176 23.9809C117.176 25.6611 118.557 26.9594 120.168 26.9594Z'
        fill='#FF620F'
      />
      <path
        d='M120.629 18.1002L124.235 0.916468L119.785 0L116.101 17.1838L120.629 18.1002Z'
        fill='#FF620F'
      />
      <path
        d='M63.7674 6.26252C65.0719 6.26252 66.0695 5.1933 66.0695 3.97135C66.0695 2.74939 64.9952 1.68018 63.7674 1.68018C62.4629 1.68018 61.4653 2.67302 61.4653 3.97135C61.4653 5.1933 62.4629 6.26252 63.7674 6.26252Z'
        fill='white'
      />
      <path
        d='M65.6858 8.40094H61.9258V24.821H65.6858V8.40094Z'
        fill='white'
      />
      <path
        d='M58.396 1.83295H54.636V24.821H58.396V1.83295Z'
        fill='white'
      />
      <path
        d='M44.2766 8.0191C39.5189 8.0191 35.9124 11.3795 35.9124 16.5728C35.9124 21.8425 39.5189 25.2792 44.2766 25.2792C49.0342 25.2792 52.6408 21.8425 52.6408 16.5728C52.6408 11.3795 49.0342 8.0191 44.2766 8.0191ZM44.2766 21.9952C41.7443 21.9952 39.7491 20.0859 39.7491 16.5728C39.7491 13.1361 41.7443 11.3031 44.2766 11.3031C46.8088 11.3031 48.804 13.2124 48.804 16.5728C48.7272 20.0859 46.8088 21.9952 44.2766 21.9952Z'
        fill='white'
      />
      <path
        d='M106.663 8.0191C101.905 8.0191 98.2986 11.3795 98.2986 16.5728C98.2986 21.8425 101.905 25.2792 106.663 25.2792C111.42 25.2792 115.027 21.8425 115.027 16.5728C115.027 11.3795 111.42 8.0191 106.663 8.0191ZM106.663 21.9952C104.131 21.9952 102.135 20.0859 102.135 16.5728C102.135 13.1361 104.131 11.3031 106.663 11.3031C109.195 11.3031 111.19 13.2124 111.19 16.5728C111.19 20.0859 109.195 21.9952 106.663 21.9952Z'
        fill='white'
      />
      <path
        d='M26.3972 8.0191C21.6395 8.0191 18.033 11.3795 18.033 16.5728C18.033 21.8425 21.6395 25.2792 26.3972 25.2792C31.1548 25.2792 34.7614 21.8425 34.7614 16.5728C34.7614 11.3795 31.1548 8.0191 26.3972 8.0191ZM26.3972 21.9952C23.8649 21.9952 21.8697 20.0859 21.8697 16.5728C21.8697 13.1361 23.8649 11.3031 26.3972 11.3031C28.9294 11.3031 30.9246 13.2124 30.9246 16.5728C30.9246 20.0859 28.9294 21.9952 26.3972 21.9952Z'
        fill='white'
      />
      <path
        d='M9.36177 8.0191C6.90622 8.0191 5.21804 9.24106 4.29721 10.6158H3.76006V1.83295H0V24.821H3.76006V22.6826H4.22047C5.1413 24.0573 6.82949 25.2792 9.28503 25.2792C13.352 25.2792 16.8819 21.9189 16.8819 16.5728C16.9586 11.2267 13.352 8.0191 9.36177 8.0191ZM8.44094 21.9952C5.67845 21.9952 3.83679 19.7804 3.83679 16.5728C3.83679 13.5943 5.75519 11.3031 8.44094 11.3031C11.1267 11.3031 13.1218 13.3652 13.1218 16.5728C13.1218 19.7041 11.2034 21.9952 8.44094 21.9952Z'
        fill='white'
      />
      <path
        d='M85.944 17.031C85.944 22.148 82.8745 25.2792 79.0378 25.2792C76.6589 25.2792 74.3569 23.9809 73.5895 21.6134H73.2826V32H69.2156V9.16469H73.2826V12.2196H73.5895C74.4336 10.0048 76.5822 8.70645 79.0378 8.70645C82.9513 8.70645 85.944 11.9905 85.944 17.031ZM81.8002 17.031C81.8002 13.5179 79.4214 12.2196 77.4263 12.2196C75.5079 12.2196 73.1291 13.5179 73.1291 17.031C73.1291 20.6205 75.4312 21.8425 77.4263 21.8425C79.4982 21.8425 81.8002 20.5442 81.8002 17.031Z'
        fill='white'
      />
      <path
        d='M98.2986 8.85919V12.4487H95.6129C92.6202 12.4487 91.9296 13.8998 91.9296 16.4964V24.821H87.8625V9.16468H91.9296V11.7613H92.3132C92.9271 10.0811 94.4618 8.85919 97.0709 8.85919H98.2986Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clipLogoWhiteIcon'>
        <rect
          width='124.235'
          height='32'
          fill='white'
        />
      </clipPath>
    </defs>
  </svg>
);

export default LogoWhiteIcon;
